export default function CurrentRank({rank, history = false}) {
    return (
        <div>
            <div className="inline-flex bg-main w-fit px-5 py-3 shadow-lg shadow-main rounded-lg">
                <div>
                    <h2 className="text-2xl">{history ? "Erreichter Rang" : "Derzeitiger Rang"}</h2>
                    <h1 className="text-4xl font-bold text-primary font-title tracking-wide">{rank}</h1>
                </div>
            </div>
        </div>
    );
}